import { useContext } from 'react';

import { useIsStaff } from '@vimeo/core/hooks/use-is-staff/useIsStaff';
import { SubjectKeyTypes, useEppoAssignment, VariationTypes } from '@vimeo/eppo';
import { ViewerContext } from '@vimeo/viewer';

const NEW_CREATE_SHOWCASE_FEATURE_FLAG = 'topnav-new-create-showcase';
const NEW_CREATE_SHOWCASE_FEATURE_FLAG_VARIANTS = { CONTROL: false, VARIANT: true };

interface Props {
  canManageTeamCollections?: boolean;
}

/**
 * Hook to determine if the user can create a showcase.
 * This is based on the user's capabilities and the A/B test feature flag assignment.
 */
export const useCanCreateShowcase = ({ canManageTeamCollections }: Props) => {
  const viewer = useContext(ViewerContext);
  const ownerId = viewer?.teamUser?.ownerId || viewer?.user?.id || 0;
  const isStaff = useIsStaff();

  const { assignment } = useEppoAssignment({
    flagKey: NEW_CREATE_SHOWCASE_FEATURE_FLAG,
    subject: {
      key: ownerId,
      keyType: SubjectKeyTypes.TEAM_OWNER_ID,
      additionalData: {
        is_staff: isStaff,
      },
    },
    defaultAssignment: NEW_CREATE_SHOWCASE_FEATURE_FLAG_VARIANTS.CONTROL,
    assignmentType: VariationTypes.BOOLEAN,
    disabled: !ownerId || !canManageTeamCollections,
  });

  return (
    assignment === NEW_CREATE_SHOWCASE_FEATURE_FLAG_VARIANTS.VARIANT && canManageTeamCollections
  );
};
